<div class="container">
  <h1 class="center">Employee Dashboard</h1>
  <div class="row">
    <h2>All Clients</h2>
    <!-- All Clients Table -->
    <div class="container-fluid table">
      <div class="header row">
        <div class="col-xs-1">#</div>
        <div class="col-xs-3">Client</div>
        <div class="col-xs-2">Renewal Date</div>
        <div class="col-xs-4">Services</div>
        <div class="col-xs-2">Service Rep</div>
      </div>
      <div class="row" [class.red]="!number || client.isSoftwareServiceRenewalDue || client.isSoftwareServiceRenewalSoon"
           *ngFor="let client of allClients; let number = index">
        <div class="col-xs-1">{{ number + 1 }}</div>
        <div class="col-xs-3"><span class="underline pointer" (click)="GoToClientDashboard(client.id)">{{ client.name }}</span></div>
        <div class="col-xs-2">{{ client.softwareServiceRenewalDate | date:'mediumDate' }}</div>
        <div class="col-xs-4">
          <span *ngFor="let softwareService of client.softwareServices">
            <span *ngIf="!softwareService.link">
              <!-- VIP Service -->
              <i class="glyphicon glyphicon-star"></i>
              {{ softwareService.name }}
            </span>
            <a class="black-text underline" *ngIf="softwareService.link" target="_blank" href="{{ softwareService.link }}">{{ softwareService.name }}</a>
            <br />
          </span>
        </div>
        <div class="col-xs-2">{{ client.serviceRep.name }}</div>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <h2>SEO Clients</h2>
    <!-- SEO Clients Table -->
    <div class="container-fluid table">
      <div class="header row">
        <div class="col-xs-1">#</div>
        <div class="col-xs-3">Client</div>
        <div class="col-xs-2">Last Updated</div>
        <div class="col-xs-2">Renewal Date</div>
        <div class="col-xs-4">Keywords</div>
      </div>
      <div class="row" [class.red]="!number" *ngFor="let client of seoClients; let number = index">
        <div class="col-xs-1">{{ number + 1 }}</div>
        <div class="col-xs-3"><span class="underline pointer" (click)="GoToClientSeoDashboard(client.id)">{{ client.name }}</span></div>
        <div class="col-xs-2">{{ client.websites[0].commitHistory[0].commit.author.date | date:'mediumDate' }}</div>
        <div class="col-xs-2">{{ client.softwareServiceRenewalDate | date:'mediumDate' }}</div>
        <div class="col-xs-4">
          <!-- //jebjebjeb -->
          <matrix-tools-chart [showDownloadButton]="false" [chartData]="client.websites[0].seoChartData">
            Loading Chart...
          </matrix-tools-chart>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <h2>SMM Clients</h2>
    <!-- SMM Clients Table -->
    <div class="container-fluid table">
      <div class="header row">
        <div class="col-xs-1">#</div>
        <div class="col-xs-3">Client</div>
        <div class="col-xs-3">Renewal Date</div>
        <div class="col-xs-5">Platforms</div>
      </div>
      <div class="row" *ngFor="let client of smmClients; let number = index">
        <div class="col-xs-1">{{ number + 1 }}</div>
        <div class="col-xs-3"><span class="underline pointer" (click)="GoToClientSmmDashboard(client.id)">{{ client.name }}</span></div>
        <div class="col-xs-3">{{ client.softwareServiceRenewalDate | date:'mediumDate' }}</div>
        <div class="col-xs-5">Facebook<br />(Upsell Instagram!?)</div>
      </div>
    </div>
  </div>
</div>
